import z from "zod"

export const GetReverReturnInfoSchema = z.object({
  orderId: z.string(),
  email: z.string().optional(),
})

export const UpsertReverIntegrationSchema = z.object({
  apiKey: z.string(),
})
